import React, { useContext, useState, useEffect } from 'react'
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Landing from './Frontend/Pages/Landing'
import Layout from './Frontend/Component/Common/Layout';
import TripMap from './Frontend/Pages/TripMap';

const AppRoutes = () => {
  return (
    <Routes>
      <Route index element={<Landing />} />
      <Route path="/trip-map" element={<TripMap />} />
      <Route
        path="/*"
        element={
          <Layout>
            <Routes>
              <Route path="/dashboard" element={<Landing />} />
            </Routes>
          </Layout>
        }
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  )
}

export default AppRoutes